module.exports = __webpack_public_path__ + "img/color_quiz_tile.6663e432.jpg";